module.exports = __webpack_public_path__ + "static/media/menu_book-24px.72619f5d.svg";